@if (isVisible()) {
  <div class="form-check form-check-sm mb-2">
    <input
      class="form-check-input"
      type="checkbox"
      [value]="value()"
      [id]="JSON.stringify(value())"
      [checked]="isChecked()"
      (change)="onToggle($event)"
    />
    <label class="form-check-label ms-2" [for]="JSON.stringify(value())">
      {{ label() }}
    </label>
  </div>
}
